var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpProviderShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7422 3.04688C13.2344 3.26562 13.5625 3.73047 13.5352 4.25C13.5352 11.2227 8.36719 14.75 6.97266 14.75C5.60547 14.75 0.4375 11.2773 0.4375 4.25C0.4375 3.73047 0.738281 3.26562 1.23047 3.04688L6.48047 0.859375C6.61719 0.804688 6.83594 0.75 7 0.75C7.13672 0.75 7.35547 0.804688 7.49219 0.859375L12.7422 3.04688ZM7 12.9727C8.72266 12.1797 11.6758 9.5 11.7852 4.55078L7 2.55469V12.9727Z",
    fill: "#4D5BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpProviderShield);
export default __webpack_public_path__ + "static/media/DlpProviderShield.0bee52d646fb199b91813191f9edfa56.svg";
export { ForwardRef as ReactComponent };